export const add = require('./icon_item-add.svg');
export const equal = require('./icon_equal.svg');
export const table = require('./icon_table-merge.svg');
export const save = require('./icon_item-save.svg');
export const del = require('./icon_item-delete.svg');
export const paste = require('./icon_paste.svg');
export const more_sq = require('./icon_more_sq.svg');
export const check = require('./icon_check.svg');
export const sortup = require('./icon_sort-up.svg');
export const sortdown = require('./icon_sort-down.svg');
export const filter = require('./icon_filter.svg');
export const more = require('./icon_more.svg');
export const edit = require('./icon_edit.svg');
export const arrowright = require('./icon_arrow-right.svg');
export const search = require('./icon_search.svg');
export const cross = require('./icon_cross.svg');
export const arrowdown = require('./icon_arrow-down.svg');
export const save_ok = require('./icon_save-ok.svg');
export const cancel = require('./icon_cancel.svg');